import PeriodResults from '@/components/kpi/period-results/PeriodResults.vue';

export default {
  name: 'MyKPI',
  components: { PeriodResults },
  data () {
    return {
      isLoading: false,
      data: null,
      job_positions: null,
      selected_job_position_id: null
    }
  },
  methods: {
    loadKpiForJobPosition () {
      this.data = { id: this.selected_job_position_id };
    },
    loadPositions () {
      this.isLoading = true;
      const path = `user/jobs/list?userApi_id=${this.$session.get('uuid')}&mode=kpi_enabled`;
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else if (response.data) {
          if (response.data.length > 1) {
            this.job_positions = response.data;
          } else {
            this.data = { id: response.data[0].id };
          }
        }
        this.isLoading = false;
      });
    }
  },
  mounted () {
    this.loadPositions();
  }
}
